import { render, staticRenderFns } from "./JangkaPendekExtendViewEmail.vue?vue&type=template&id=2017d284&scoped=true&lang=pug&"
import script from "./JangkaPendekExtendViewEmail.vue?vue&type=script&lang=js&"
export * from "./JangkaPendekExtendViewEmail.vue?vue&type=script&lang=js&"
import style0 from "./JangkaPendekExtendViewEmail.vue?vue&type=style&index=0&id=2017d284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2017d284",
  null
  
)

export default component.exports